import ShowCase from '@components/LocalMerchant/ShowCase'
import ShowCaseList from '@components/LocalMerchant/ShowCase/ShowCaseList'
import Info from '@components/LocalMerchant/ShowCase/Edit'
import CaseExample from '@components/LocalMerchant/ShowCase/CaseExample'

export default {
  path: 'showCase',
  component: ShowCase,
  indexRoute: {
    component: ShowCaseList
  },
  stat: '推荐橱窗/首页',
  childRoutes: [
    {
      path: 'Info(/:id/:seat)',
      component: Info,
      stat: '推荐橱窗/编辑橱窗'
    },
    {
      path: 'caseExample',
      component: CaseExample,
      stat: '推荐橱窗/优秀范例'
    }
  ]
}
